module.exports = __webpack_public_path__ + "img/frame (124).271cb86b.jpg";